let config = {
  inputLabel: 'imageUrl',
  key: 'logourl',
  inputType: 'textfield',
};

export default config;
